import { combineReducers } from '@ngrx/store';
import { searchResultsReducer } from './search-results/search-results.reducer';
import { similarResultsReducer } from './similar-results/similar-results.reducer';
import { mapResultsReducer } from './map-results/map-results.reducer';
import { ResultsState } from '@immosky/types';

export const resultsReducer = combineReducers<ResultsState>({
  searchResults: searchResultsReducer,
  similarResults: similarResultsReducer,
  mapResults: mapResultsReducer,
});
